import { render, staticRenderFns } from "./WTabs.vue?vue&type=template&id=24036a3e&scoped=true&"
import script from "./WTabs.vue?vue&type=script&lang=js&"
export * from "./WTabs.vue?vue&type=script&lang=js&"
import style0 from "./WTabs.vue?vue&type=style&index=0&id=24036a3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24036a3e",
  null
  
)

export default component.exports